import React from 'react'
import ViewForm from '../../components/User/DynamicForms/ViewForm';
import Layout from './Layout'; 

export const ViewFormPage = () => <Layout><ViewForm /></Layout>